import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cada98d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stock-oneclick-modal" }
const _hoisted_2 = { class: "confirm-order-content" }
const _hoisted_3 = { class: "confirm-order-title" }
const _hoisted_4 = { style: {"line-height":"20px"} }
const _hoisted_5 = {
  key: 0,
  style: {"line-height":"20px"}
}
const _hoisted_6 = {
  key: 1,
  style: {"line-height":"20px"}
}
const _hoisted_7 = {
  key: 0,
  class: "tiktokTips"
}
const _hoisted_8 = { style: {"margin-top":"20px","padding-top":"20px","border-top":"1px solid #F9F9F9"} }
const _hoisted_9 = { class: "flex-ter text-name-order mt_8" }
const _hoisted_10 = { class: "name" }
const _hoisted_11 = { class: "text-rt confirm-btns" }

import { t } from '@/plugins/i18n'
import { ref, nextTick, toRaw, watch, computed } from 'vue'
import { stockOneclickColumns, tableConfigStockOneclick } from './data'
import { pageOnTheWayStockApi } from '@/apis/stock'
import { getShopOrderProductList } from '@/apis/order'
import { useStore } from 'vuex'
import STable from '@/components/Table/index.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import { ShopType } from '@/common/const'

export default /*#__PURE__*/_defineComponent({
  props: ['selectedShopids'],
  emits: ['success'],
  setup(__props, { expose, emit }) {

const props = __props

const store = useStore()
const isTikTokShop = computed(() => store.getters.shopInfo?.customerShopPlatform === ShopType.TIKTOK)



const useOnTheWayStock = ref(true)
const visible = ref(false)

const pageData = ref({
    page: 1,
    limit: 10
})

const filterData = computed(() => {
    return {
        shopOrderIds: props.selectedShopids
    }
})

const showBuy = ref(true)

const open = (buy = true) => {
    visible.value = true
    useOnTheWayStock.value = true
    showBuy.value = buy
}
const cancel = () => {
    visible.value = false
}

const commit = () => {
    cancel()
    emit('success', useOnTheWayStock.value)
}

expose({
    open
})

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
      "destroy-on-close": "",
      onClose: cancel,
      draggable: "",
      width: 1050
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('处理中库存提醒')), 1),
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('以下商品有正在处理中的库存，请选择处理方式：')), 1),
            _createVNode(_component_el_radio_group, {
              modelValue: useOnTheWayStock.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((useOnTheWayStock).value = $event)),
              style: {"margin-top":"20px","display":"flex","align-items":"normal","flex-direction":"column"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: true,
                  style: {"margin-bottom":"12px"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('使用处理中库存进行下单（无需支付商品费用，处理中库存成品上架后即可发货）')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: false }, {
                  default: _withCtx(() => [
                    (!_unref(isTikTokShop))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(showBuy.value ? _unref(t)('不使用在途库存，直接下单重新采购') :
                                _unref(t)('不使用在途库存')), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_6, "処理中在庫を使用せず、在庫補充を行う"))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (_unref(isTikTokShop))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, " ※TikTok店舗の場合、注文は在庫商品からのみ発送可能なため、手動で新規「在庫保管注文」を発注する必要があります。"))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(STable, {
                columns: _unref(stockOneclickColumns),
                tableConfig: _unref(tableConfigStockOneclick),
                "page-data": pageData.value,
                "onUpdate:page-data": _cache[1] || (_cache[1] = ($event: any) => ((pageData).value = $event)),
                api: _unref(pageOnTheWayStockApi),
                "header-row-class-name": "stock-oneclick-header-row",
                filterData: _unref(filterData),
                fixed: true,
                "max-height": "600"
              }, {
                productSkuImg: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_9, [
                    (row.productMainImg)
                      ? (_openBlock(), _createBlock(ShoppingPreview, {
                          key: 0,
                          image: row.productMainImg
                        }, null, 8, ["image"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(row.productTitle), 1)
                  ])
                ]),
                _: 1
              }, 8, ["columns", "tableConfig", "page-data", "api", "filterData"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_button, {
            type: "default",
            onClick: cancel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: commit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('同意1')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})